import { Component, ViewChild, Input, OnInit, OnDestroy } from '@angular/core';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { AliasName } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { NgForm } from '@angular/forms';
import { TriggerRecordTogglePayload, FilterableRecordSubTypes, ScreeningAdditionalData } from 'src/app/models/screeningInvite';
import { VendorResponseTypes } from 'src/app/packages-module/models/searchPackage';
import { take, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { ScreeningService } from '../../services/screening.service';

@Component({
  selector: 'app-alias-list',
  templateUrl: './alias-list.component.html',
  styleUrls: ['./alias-list.component.less']
})
export class AliasListComponent implements OnInit, OnDestroy {
  @ViewChild('appData', {}) ngForm: NgForm;
  @Input() screeningId : number;
  @Input() clientId : number;
  @Input() toggleAll : Observable<boolean>;
  // @Input() pkg : ScreeningAdditionalData;

  public aliasSearch : string;
  $toggleAllSub : Subscription;
  lastKey : any = {
    key : 'excludeFromReport',
    ascending : false
  };
  
  public get personase() : number {
    return this.screening.screenings[0].additionalData.find(as=>{return as.searchTypeEnum == VendorResponseTypes.Person;}).searchEntryId;
  }
  
  public get creditase() : number {
    return this.screening.screenings[0].additionalData.find(as=>{return as.searchTypeEnum == VendorResponseTypes.Credit;}).searchEntryId;
  }

  public get filteredAliases() : AliasName[] {
    if(this.aliasSearch) {
      return this.appData.sortByKey(this.appData.aliasRecords.filter((str: AliasName) => { 
        return str.fullName.toLowerCase().indexOf(this.aliasSearch.toLowerCase()) !== -1; 
      }),this.lastKey.key,this.lastKey.ascending);
    }
    return this.appData.sortByKey(this.appData.aliasRecords,this.lastKey.key,this.lastKey.ascending);
  }
  
  constructor(public appData: ApplicantDataService, public toast : ToastrService, public screening : ScreeningService){}
  ngOnDestroy(): void {
    this.$toggleAllSub.unsubscribe();
  }
  ngOnInit(): void {
    this.appData.GetAliasNameRecordsForApplicant(this.screeningId);
    this.$toggleAllSub = this.toggleAll.subscribe((val :boolean)=> {
        console.debug('Toggle All got called for the following aliases.', this.filteredAliases);
        // are all the aliases selected of a single type?
        let ssn_aliases = this.filteredAliases.filter(al=>al.tableName.indexOf('Person') > -1);
        let credit_aliases = this.filteredAliases.filter(al=>al.tableName.indexOf('Credit') > -1);

        let plds : TriggerRecordTogglePayload[] = [];
      
        if(ssn_aliases.length > 0){
          let pld = this.buildTogglePayload(val,ssn_aliases,VendorResponseTypes.Person);
          plds.push(pld);
        }
        if(credit_aliases.length > 0){
          let pld = this.buildTogglePayload(val,credit_aliases,VendorResponseTypes.Credit);
          plds.push(pld);
        }
       
        this.fireUpdate(plds);
    });
  }

  searchAlias(){
    // console.debug('alias search was updated',this.aliasSearch);
  }

  /// This method assumes you are passing aliasName[] records from the same table**
  buildTogglePayload(include : boolean, records: AliasName[], type : VendorResponseTypes) : TriggerRecordTogglePayload{
    let pld = new TriggerRecordTogglePayload();
    pld.recordIds = records.map(fa=>fa.id);
    pld.recordsIncluded = include;
    pld.searchType = type;
    if(type == VendorResponseTypes.Person) pld.searchEntryId = this.personase;
    else pld.searchEntryId = this.creditase;
    pld.subType = FilterableRecordSubTypes.Alias;
    pld.screeningId = this.screeningId;
    pld.clientId = this.clientId;

    return pld;
  }

  fireUpdate(rcrds : TriggerRecordTogglePayload[]){
    this.appData.ToggleRecord2(rcrds).pipe(take(1), tap(_=>{
      console.info(_);
     })).subscribe(()=>{
       this.toast.success(`Record Toggle Success`);
       rcrds.forEach(rc=>{
         rc.recordIds.forEach(r=>{
           this.appData._aliasRecords.find(al=>{return al.id == r}).excludeFromReport = !rc.recordsIncluded;
         })
        });
     },
     ()=>{this.toast.error(`Record Toggle Failed`);});
  }
  
  toggleRecordStatus(include : boolean, record : AliasName){
    let searchType;
    if(record.tableName == "Person_Alias")
      searchType = VendorResponseTypes.Person;
    else
      searchType = VendorResponseTypes.Credit;

    let pld = this.buildTogglePayload(include,[record],searchType);
   
    this.fireUpdate([pld]);

  }

  sort(key : string){
    if(this.lastKey.key == key){
      this.lastKey.ascending = !this.lastKey.ascending;
    }else{
      this.lastKey.key = key;
      this.lastKey.ascending = false;
    }
  }

}
